import { z } from 'zod';

/**
 * The order lifecycle, in order. Forward-only: a supplier advances one step at a
 * time and there is no tenant cancel path — legality is enforced server-side by
 * ORDER_STATUS_TRANSITIONS, not by this array's ordering.
 *
 * The frontend previously restated this union twice (as `SupplierOrderStatus`);
 * it now imports it from here.
 */
export const ORDER_STATUSES = [
  'accepted',
  'confirmed',
  'in_progress',
  'manufactured',
  'shipped',
  'delivered',
  'cancelled',
] as const;

export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const orderStatusSchema = z.enum(ORDER_STATUSES);

/**
 * Payment lifecycle tracked on the order (the order, not the quote, is the
 * payable artifact). Distinct from the payments table's own status, which
 * models processor-level states.
 */
export const ORDER_PAYMENT_STATUSES = ['pending', 'paid'] as const;

export type OrderPaymentStatus = (typeof ORDER_PAYMENT_STATUSES)[number];

export const orderPaymentStatusSchema = z.enum(ORDER_PAYMENT_STATUSES);
